





















import { defineComponent } from '@vue/composition-api'
import ComingSoonCard from '@/components/cards/ComingSoonCard.vue'
import MemoComponent from '@/modules/local/memo'
import MemoList from '@/templates/MemoList.vue'
import LoadingCircle from '@/components/LoadingCircle.vue'
export default defineComponent({
  components: { ComingSoonCard, MemoList, LoadingCircle },
  props: {
    tabs: {
      type: Object
    }
  },
  setup(_, ctx) {
    const memoComponent = MemoComponent(ctx)
    memoComponent.getAll()
    return {
      ...memoComponent
    }
  }
})
